import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BookOutlined, UserOutlined, FileTextOutlined, DollarOutlined, DashboardOutlined } from '@ant-design/icons';
import { getUserInfo } from '../../utils/auth';
import { UserRole } from '../../constants/user';
import './styles.css';

const MobileBottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = getUserInfo();
  // 全量角色并集（主角色 ∪ user_role 表），基础角色可多选
  const roleList = [userInfo?.role, ...(userInfo?.roles || [])].filter(Boolean) as UserRole[];
  const hasRole = (role: UserRole) => roleList.includes(role);
  const isAdmin = hasRole(UserRole.ADMIN);
  const hasStaff = hasRole(UserRole.STAFF);
  const hasLawyer = hasRole(UserRole.LAWYER);
  const hasFinance = hasRole(UserRole.FINANCE);

  const getNavItems = () => {
    const items: Array<{ key: string; icon: JSX.Element; label: string }> = [];

    // 工作台：员工/律师（或超管）
    if (isAdmin || hasStaff || hasLawyer) {
      items.push({ key: '/workspace', icon: <BookOutlined />, label: '工作台' });
    }

    // 线索：员工（或超管）
    if (isAdmin || hasStaff) {
      items.push({ key: '/leads', icon: <UserOutlined />, label: '线索' });
    }

    // 案件：员工/律师（或超管）
    if (isAdmin || hasStaff || hasLawyer) {
      items.push({ key: '/cases', icon: <FileTextOutlined />, label: '案件' });
    }

    // 财务：财务（或超管）
    if (isAdmin || hasFinance) {
      items.push({ key: '/finance', icon: <DollarOutlined />, label: '财务' });
    }

    // 数据看板：仅超管
    if (isAdmin) {
      items.push({ key: '/dashboard', icon: <DashboardOutlined />, label: '数据' });
    }

    return items;
  };

  const navItems = getNavItems();

  const isActive = (key: string) => {
    return location.pathname.startsWith(key);
  };

  return (
    <div className="mobile-bottom-nav">
      {navItems.map(item => (
        <div
          key={item.key}
          className={`nav-item ${isActive(item.key) ? 'active' : ''}`}
          onClick={() => navigate(item.key)}
        >
          <div className="nav-icon">{item.icon}</div>
          <div className="nav-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default MobileBottomNav;
